import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["allowClear", "disabled", "valueAmount", "size", "option", "maxTagCount", "loading", "labelInValue", "prefixCls", "className", "mode", "style", "isOpen", "value", "defaultValue", "showSearch", "tagProps", "placeholder", "onSearch", "onChange", "onSelect"];
import React, { useMemo } from 'react';
import Dropdown from '@uiw/react-dropdown';
import Icon from '@uiw/react-icon';
import Menu from '@uiw/react-menu';
import Input from '@uiw/react-input';
import Tag from '@uiw/react-tag';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TagSize = {
  large: 25,
  default: 20,
  small: 17
};
export default function SearchSelect(props) {
  var _style$width;
  var {
      allowClear = false,
      disabled = false,
      valueAmount,
      size = 'default',
      option = [],
      maxTagCount,
      loading = false,
      labelInValue = false,
      prefixCls = 'w-search-select',
      className,
      mode = 'single',
      style,
      value,
      defaultValue,
      showSearch = false,
      tagProps = {},
      placeholder,
      onSearch,
      onChange,
      onSelect
    } = props,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  var isMultiple = useMemo(() => mode === 'multiple', [mode]);
  var [innerIsOpen, setInnerIsOpen] = useState(false);
  var [selectedValue, setSelectedValue] = useState([]);
  var [selectedLabel, setSelectedLabel] = useState('');
  var [selectIconType, setSelectIconType] = useState('');
  var inputRef = useRef(null);
  var omitTagCount = useMemo(() => maxTagCount && selectedValue.length > maxTagCount ? selectedValue.length - maxTagCount : 0, [selectedValue.length]);
  var divRef = useRef(null);
  var tagContentRef = useRef(null);
  var [tagClientWidth, setTagClientWidth] = React.useState(180);
  var valueVerify = value => {
    return value !== undefined && value !== '';
  };
  var valueRef = useRef();
  valueRef.current = useMemo(() => selectedValue, [selectedValue]);
  useEffect(() => {
    if (!valueVerify(value) && valueVerify(defaultValue)) {
      selectedValueChange(defaultValue);
    }
  }, []);
  useEffect(() => {
    if (disabled) {
      setInnerIsOpen(false);
    }
  }, [disabled]);
  useEffect(() => {
    if (valueVerify(value)) {
      selectedValueChange(value);
    } else {
      setSelectedValue([]);
      setSelectedLabel('');
    }
  }, [JSON.stringify(value)]);
  var getSelectOption = (option, value) => {
    var findResult = option.find(item => item.value === value);
    return findResult;
  };
  function selectedValueChange(changeValue) {
    var opts = [];
    if (labelInValue) {
      if (Array.isArray(changeValue)) {
        opts = changeValue;
      } else {
        opts.push(changeValue);
      }
    } else {
      if (Array.isArray(changeValue)) {
        opts = changeValue.map(v => getSelectOption(option, v)).filter(m => !!m);
      } else {
        var findResult = getSelectOption(option, changeValue);
        if (findResult) {
          setSelectedLabel(findResult.label);
          opts.push(findResult);
        }
      }
    }
    if (!isMultiple && opts.length > 0) setSelectedLabel(opts[0].label || '');
    setSelectedValue(opts.slice(0, valueAmount));
  }
  function removeSelectItem(index) {
    var selectedValue = valueRef.current;
    selectedValue.splice(index, 1);
    var values = [...selectedValue];
    return values;
  }
  var selectedLabelChange = value => {
    setSelectedLabel(value);
    showSearch && (onSearch == null ? void 0 : onSearch(value));
  };
  function handleItemClick(item) {
    setInnerIsOpen(false);
    var values = [item];
    setSelectedLabel(item.label);
    var resultValue = item.value;
    handleChange(resultValue, values);
  }
  function handleItemsClick(index, item) {
    var values = index !== -1 ? removeSelectItem(index) : [...selectedValue.slice(0, valueAmount ? valueAmount - 1 : undefined), item];
    var resultValue = values.map(item => item.value);
    handleChange(resultValue, values);
  }
  function handleChange(resultValue, values) {
    setSelectedLabel('');
    onSelect && onSelect(resultValue);
    handleSelectChange(resultValue, values); // 支持form组件

    value === undefined && setSelectedValue(values); // 如果受控于父组件则不需要内部维护状态
  }

  // 渲染icon
  function renderSelectIcon(type) {
    var selectIconType;
    if (type === 'enter' && allowClear && (selectedValue.length > 0 || selectedLabel)) {
      selectIconType = 'close';
    } else {
      selectIconType = '';
    }
    setSelectIconType(selectIconType);
  }
  // handle change
  function handleInputChange(value) {
    setInnerIsOpen(true);
    setSelectIconType(showSearch && value ? 'loading' : '');
    // setSelectedLabel(value);
    // showSearch && onSearch && onSearch(value);
    selectedLabelChange(value);
  }
  // 清除选中的值
  function resetSelectedValue(e) {
    var _inputRef$current;
    e.stopPropagation();
    (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
    setSelectedValue([]);
    handleInputChange('');
    setInnerIsOpen(false);
    handleSelectChange('', []);
  }
  function handleSelectChange(value, options) {
    if (!onChange) return;
    onChange(labelInValue ? options : value);
  }
  function inputKeyDown(e) {
    if (isMultiple && selectedValue.length > 0 && !selectedLabel && e.keyCode === 8) {
      handleItemsClick(selectedValue.length - 1);
    }
  }
  function onVisibleChange(isOpen) {
    var selectedValue = valueRef.current;
    setInnerIsOpen(isOpen);
    if (!isOpen) selectedLabelChange('');
    if (!isMultiple && selectedValue.length > 0) {
      setSelectedLabel(selectedValue[0].label);
    }
  }
  React.useEffect(() => {
    var _tagContentRef$curren;
    if ((_tagContentRef$curren = tagContentRef.current) != null && _tagContentRef$curren.clientWidth) {
      var _tagContentRef$curren2;
      setTagClientWidth((_tagContentRef$curren2 = tagContentRef.current) == null ? void 0 : _tagContentRef$curren2.clientWidth);
    }
  }, [tagContentRef.current]);
  return /*#__PURE__*/_jsx(Dropdown, _extends({
    className: cls,
    trigger: "click",
    style: {
      marginTop: 5
    },
    overlayStyl: {
      width: 100
    },
    disabled: disabled
  }, others, {
    onVisibleChange: onVisibleChange,
    isOpen: innerIsOpen,
    menu: /*#__PURE__*/_jsx(Menu, {
      bordered: true,
      style: {
        minHeight: 25,
        maxHeight: 280,
        minWidth: (_style$width = style == null ? void 0 : style.width) != null ? _style$width : 200,
        overflowY: 'scroll',
        width: style == null ? void 0 : style.width
      },
      children: !option || option.length === 0 ? /*#__PURE__*/_jsx("div", {
        style: {
          color: '#c7c7c7',
          fontSize: 12
        },
        children: loading ? '正在加载数据...' : '没有数据'
      }) : option.map(item => {
        var index = selectedValue.findIndex(finds => finds.value === item.value);
        return /*#__PURE__*/_jsx(Menu.Item, {
          active: index !== -1,
          text: item.label,
          onClick: () => isMultiple ? handleItemsClick(index, item) : handleItemClick(item)
        }, index);
      })
    }),
    children: /*#__PURE__*/_jsx("div", {
      ref: divRef,
      onMouseOver: () => renderSelectIcon('enter'),
      onMouseLeave: () => renderSelectIcon('leave'),
      onClick: () => {
        var _inputRef$current2;
        return (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.focus();
      },
      style: _extends({
        width: '100%',
        maxWidth: 'none'
      }, style),
      children: isMultiple ? /*#__PURE__*/_jsxs("div", {
        className: [prefixCls + "-inner", prefixCls + "-search-" + showSearch, prefixCls + "-" + size].filter(Boolean).join(' ').trim(),
        children: [/*#__PURE__*/_jsxs("div", {
          ref: tagContentRef,
          className: [prefixCls + "-tag-content", disabled && prefixCls + "-tag-content-disabled"].filter(Boolean).join(' ').trim(),
          children: [isMultiple && selectedValue.slice(0, maxTagCount).map((item, index) => {
            return /*#__PURE__*/_jsx(Tag, _extends({
              style: _extends({
                height: TagSize[size],
                margin: 1,
                display: 'flex',
                alignItems: 'center'
              }, tagProps.style),
              color: "#393E48"
            }, tagProps, {
              closable: true,
              disabled: disabled,
              onClose: e => {
                e.stopPropagation();
                handleItemsClick(index, item);
              },
              children: /*#__PURE__*/_jsx("span", {
                style: {
                  maxWidth: tagClientWidth - 63,
                  textOverflow: 'ellipsis',
                  overflow: 'auto'
                },
                children: item.label
              })
            }), index);
          }), !!omitTagCount && /*#__PURE__*/_jsxs(Tag, {
            style: {
              height: 20,
              margin: 1,
              display: 'flex',
              alignItems: 'center'
            },
            disabled: true,
            children: ["+", omitTagCount, " \u2026", ' ']
          }), /*#__PURE__*/_jsx(Input, {
            style: {
              flex: 1,
              width: showSearch ? 0 : 50
            },
            className: prefixCls + "-input-contents",
            readOnly: !showSearch,
            size: size,
            ref: inputRef,
            disabled: disabled,
            onKeyDown: inputKeyDown,
            onChange: e => handleInputChange(e.target.value),
            value: selectedLabel,
            placeholder: selectedValue.length ? '' : placeholder
          })]
        }), !disabled && (selectIconType === 'close' || selectIconType === 'loading' && loading) && /*#__PURE__*/_jsx(Icon, {
          className: prefixCls + "-multiple-colse",
          type: selectIconType,
          spin: loading && selectIconType === 'loading',
          onClick: resetSelectedValue
        })]
      }) : /*#__PURE__*/_jsx(Input, {
        className: prefixCls + "-search-" + showSearch,
        readOnly: !showSearch,
        size: size,
        ref: inputRef,
        disabled: disabled,
        onChange: e => handleInputChange(e.target.value),
        value: selectedLabel,
        placeholder: placeholder,
        addonAfter: !disabled && (selectIconType === 'close' || selectIconType === 'loading' && loading) && /*#__PURE__*/_jsx(Icon, {
          type: selectIconType,
          className: prefixCls + "-singe-colse",
          color: "#393e48",
          spin: loading && selectIconType === 'loading',
          onClick: resetSelectedValue
        })
      })
    })
  }));
}